import { MetricsManager } from '../../engine/streamrapp/MetricsManager';
import { MetricsServiceOutput, } from './MetricsServiceOutput';
export class MetricsService {
    static instance;
    output;
    metricsBuffer = {};
    updateIntervalId = null;
    UPDATE_INTERVAL_MS = 1000; // Write output once per second
    static getInstance() {
        if (!MetricsService.instance) {
            MetricsService.instance = new MetricsService();
        }
        return MetricsService.instance;
    }
    static getOutput() {
        return MetricsServiceOutput.getReactiveOutput();
    }
    // ------------- Singleton implementation end
    constructor() {
        console.log('MetricsService constructor called');
        this.output = new MetricsServiceOutput();
        const metricsManager = MetricsManager.getInstance();
        console.log('Setting up MetricsManager listener');
        // Collect metrics in buffer with timestamps
        metricsManager.on('metricLogged', (metric, value) => {
            if (!this.metricsBuffer[metric]) {
                this.metricsBuffer[metric] = [];
            }
            this.metricsBuffer[metric].push({
                value,
                recordedAt: Date.now(),
            });
        });
        // Start periodic output writing
        this.startPeriodicUpdate();
    }
    startPeriodicUpdate() {
        if (this.updateIntervalId !== null) {
            return; // Already started
        }
        this.updateIntervalId = setInterval(() => {
            this.writeOutput();
        }, this.UPDATE_INTERVAL_MS);
        console.log(`MetricsService: Started periodic updates every ${this.UPDATE_INTERVAL_MS}ms`);
    }
    writeOutput() {
        if (Object.keys(this.metricsBuffer).length === 0) {
            return; // No metrics to write
        }
        // Count total data points
        const _totalPoints = Object.values(this.metricsBuffer).reduce((sum, points) => sum + points.length, 0);
        // Write all buffered data points to output at once
        this.output.addDataPoints(this.metricsBuffer);
        //console.log(
        //    `MetricsService: Wrote ${totalPoints} data points across ${Object.keys(this.metricsBuffer).length} metrics to output`,
        //);
        // Clear buffer for next batch
        this.metricsBuffer = {};
    }
    async init() {
        // No initialization needed
    }
    destroy() {
        if (this.updateIntervalId !== null) {
            clearInterval(this.updateIntervalId);
            this.updateIntervalId = null;
            console.log('MetricsService: Stopped periodic updates');
        }
    }
}
